import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import {connect, useDispatch} from "react-redux";
import {getAllInformation} from "../../store/information/actions";

const SidebarContent = props => {
  const ref = useRef();

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  },[]);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = '/dashboard'

    new MetisMenu("#side-menu")
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }

  }, [props.location.pathname,activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const {info} = props.information

  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getAllInformation())
  },[])

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref} className="sidebar-menu-scroll">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">


            <li>
              <Link to="/logistic/sent" className=" waves-effect">
                <i className="uil-plane-fly"></i>
                <span className="badge rounded-pill bg-info float-end">{info.productsSent}</span>
                <span>გამოგზავნილი</span>
              </Link>
            </li>


            <li>
              <Link to="/logistic/arrived" className=" waves-effect">
                <i className="uil-plane-arrival"></i>
                <span className="badge rounded-pill bg-info float-end">{info.productsArrived}</span>
                <span>ჩამოსული</span>
              </Link>
            </li>

            <li>
              <Link to="/logistic/giveaway" className=" waves-effect">
                <i className="uil-archive"></i>
                <span>ამანათის გაცემა ხელით</span>
              </Link>
            </li>

            <li>
              <Link to="/logistic/sorting" className=" waves-effect">
                <i className="uil-sort-amount-down"></i>
                <span>დახარისხება</span>
              </Link>
            </li>
            <li>
              <Link to="/logistic/sortingNew" className=" waves-effect">
                <i className="uil-sort-amount-down"></i>
                <span>დახარისხება <i style={{color:'#ff9900'}}>NEW</i></span>
              </Link>
            </li>

            <li className="menu-title" style={{ fontSize: '16px'}}>საკურიერო</li>
            <li>
              <Link to="/courier" className=" waves-effect">
                <span className="badge rounded-pill bg-info float-end">{info.couriersAll}</span>
                <i className="uil-plane-departure"></i>
                <span>საკურიერო მომსახურეიბა</span>
              </Link>
            </li>
            <li>
              <Link to="/courierlist" className=" waves-effect">
                <i className="uil-plane-departure"></i>
                <span>საკურიეროს არქივი</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}
const mapStateToProps = state => {
  const {
    information
  } = state
  return {
    information
  }
};

export default withRouter(connect(mapStateToProps)(SidebarContent))
